module.exports = __webpack_public_path__ + "img/investec-zebra.7bf99309.png";